export { default } from "./PromotionCard.jsx";
